"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarknetPricesContractConnector = void 0;
const prices_abi_json_1 = __importDefault(require("./prices_abi.json"));
const StarknetPricesContractAdapter_1 = require("./StarknetPricesContractAdapter");
const StarknetContractConnector_1 = require("../StarknetContractConnector");
class StarknetPricesContractConnector extends StarknetContractConnector_1.StarknetContractConnector {
    constructor(account, contractAddress, network = "goerli-alpha") {
        super(account, contractAddress, prices_abi_json_1.default, network);
    }
    async getAdapter() {
        return new StarknetPricesContractAdapter_1.StarknetPricesContractAdapter(await this.getContract());
    }
}
exports.StarknetPricesContractConnector = StarknetPricesContractConnector;
//# sourceMappingURL=StarknetPricesContractConnector.js.map